import { render, staticRenderFns } from "./DropBetweenZone.vue?vue&type=template&id=f9201236&"
import script from "./DropBetweenZone.vue?vue&type=script&lang=js&"
export * from "./DropBetweenZone.vue?vue&type=script&lang=js&"
import style0 from "./DropBetweenZone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports